/** @format */

import React, { useEffect, useState } from "react";
import { Box, FlexBox } from "../../layouts";
import { TextField, ErrorMessage } from "../../ui-parts";

export const PhoneNumberElement = ({
  flexBoxMt,
  phoneNumberObj,
  phoneNumberType,
  setPhoneNumberStateHandler,
  phoneNumberValidateObj,
}: {
  flexBoxMt?: number;
  phoneNumberObj: {
    before_value: string;
    middle_value: string;
    after_value: string;
  };
  phoneNumberType: string;
  setPhoneNumberStateHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  phoneNumberValidateObj: {
    before_value: { isValidate: boolean; message: string };
    middle_value: { isValidate: boolean; message: string };
    after_value: { isValidate: boolean; message: string };
  };
}) => {
  const [phoneErrorMsg, setPhoneErrorMsg] = useState<string>("");
  useEffect(() => {
    setPhoneErrorMsg(phoneNumberValidateObj.before_value.message);
  }, [phoneNumberValidateObj.before_value.message]);
  useEffect(() => {
    setPhoneErrorMsg(phoneNumberValidateObj.middle_value.message);
  }, [phoneNumberValidateObj.middle_value.message]);
  useEffect(() => {
    setPhoneErrorMsg(phoneNumberValidateObj.after_value.message);
  }, [phoneNumberValidateObj.after_value.message]);

  return (
    <>
      <FlexBox mt={flexBoxMt}>
        <TextField
          mt={0}
          id={`${phoneNumberType}_before`}
          placeholder="000"
          defaultValue={phoneNumberObj.before_value}
          width={80}
          onChange={setPhoneNumberStateHandler}
          iserror={phoneNumberValidateObj.before_value.message}
          isErrorText={false}
        />
        <Box mt={10}>-</Box>
        <TextField
          mt={0}
          id={`${phoneNumberType}_middle`}
          placeholder="0000"
          defaultValue={phoneNumberObj.middle_value}
          width={80}
          onChange={setPhoneNumberStateHandler}
          iserror={phoneNumberValidateObj.middle_value.message}
          isErrorText={false}
        />
        <Box mt={10}>-</Box>
        <TextField
          mt={0}
          id={`${phoneNumberType}_after`}
          placeholder="0000"
          defaultValue={phoneNumberObj.after_value}
          width={80}
          onChange={setPhoneNumberStateHandler}
          iserror={phoneNumberValidateObj.after_value.message}
          isErrorText={false}
        />
      </FlexBox>
      <ErrorMessage ApiErrMsg={phoneErrorMsg} />
    </>
  );
};
